export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';
export const toggleSideNav = () => ({
  type: TOGGLE_SIDE_NAV,
  payload: {},
});

export const TOGGLE_ACCORDION = 'TOGGLE_ACCORDION';
export const toggleAccordion = (key) => ({
  type: TOGGLE_ACCORDION,
  payload: { key },
});
